/**
 * Whether this page is open inside another app's built-in browser — Facebook,
 * Instagram, TikTok and the like — rather than in a real browser.
 *
 * Google refuses to sign anyone in from those ("403: disallowed_useragent"),
 * and people arriving from an ad tap straight into one. So instead of a button
 * that leads to Google's error page, the sign-in shows how to open the page in
 * the phone's own browser.
 *
 * User-agent sniffing, which is normally the wrong tool; here it is the only
 * one, and the same signal Google itself goes by. A miss costs a Google error
 * page; a false alarm costs a hint the person can ignore — both recoverable.
 */
const IN_APP_PATTERNS = [
  /FBAN|FBAV|FB_IAB|FBIOS|FB4A/i, // Facebook, Messenger
  /Instagram/i,
  /musical_ly|TikTok|BytedanceWebview|trill_/i,
  /LinkedInApp/i,
  /Snapchat/i,
  /\bLine\//i,
  /Pinterest/i,
  /; wv\)/i, // any Android WebView
];

export const isInAppBrowser = (userAgent = globalThis.navigator?.userAgent ?? "") =>
  IN_APP_PATTERNS.some((pattern) => pattern.test(userAgent));
